import {
    ActivateUserResponse,
    CreateInternalUserRequest,
    CreateUserRequest,
    CreateUserResponse,
    DeactivateUserResponse,
    EditRoles,
    GetAgencyUserResponse,
    GetCustomerDetailsResponse,
    GetUserResponse,
    IdentificationType,
    UpdateUserRequest,
    UpdateUserResponse,
    UpdateUserRoleResponse,
    UserRole
} from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';
import { convertToEnumKey } from 'Application/utils';

export const createUser = async (userData: CreateUserRequest) => {
    const url = '/api/v1/users';

    try {
        const response: AxiosResponse<CreateUserResponse> = await APICallInstance.post(url, userData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createInternalUser = async (userData: CreateInternalUserRequest) => {
    const url = '/api/v1/users';

    try {
        const response: AxiosResponse<CreateUserResponse> = await APICallInstance.post(url, userData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getUsers = async (searchValue?: string, page?: number, pageSize?: number) => {
    const searchSection = searchValue && searchValue !== '' ? `&searchValue=${searchValue}` : '';
    const url = page && pageSize ? `api/v1/users?page=${page}&pageSize=${pageSize}${searchSection}` : 'api/v1/users';

    try {
        const response: AxiosResponse<GetUserResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchAgencyUsers = async (name: string) => {
    const url = `api/v1/users/agency?name=${encodeURIComponent(name)}`;

    try {
        const response: AxiosResponse<GetAgencyUserResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const fetchInternalUsers = async (searchValue?: string, page?: number, pageSize?: number, countryValue?: string) => {
    const searchSection = searchValue && searchValue !== '' ? `&searchValue=${searchValue}` : '';
    const countrySection = countryValue && countryValue !== 'All' ? `&regionName=${countryValue}` : '';

    const url =
        page && pageSize
            ? `api/v1/users/internal?page=${page}&pageSize=${pageSize}${searchSection}${countrySection}`
            : `api/v1/users/internal`;

    try {
        const response: AxiosResponse<GetAgencyUserResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCustomerDetails = async (identificationNumber: string, identificationType: string) => {
    const url = 'api/v1/customer';

    try {
        const response: AxiosResponse<GetCustomerDetailsResponse> = await APICallInstance.get(url, {
            params: {
                identificationNumber: identificationNumber,
                identificationType: identificationType
            }
        });
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const handleActivateUsers = async (emailAddress: string) => {
    const url = `api/v1/users/activate?emailAddress=${encodeURIComponent(emailAddress)}`;

    try {
        const response: AxiosResponse<ActivateUserResponse> = await APICallInstance.put(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const handleDeactivateUsers = async (emailAddress: string) => {
    const url = `api/v1/users/deactivate?emailAddress=${encodeURIComponent(emailAddress)}`;

    try {
        const response: AxiosResponse<DeactivateUserResponse> = await APICallInstance.put(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const handleEditUsers = async (userId: number, userData: UpdateUserRequest) => {
    const url = `api/v1/users/${userId}/profile`;

    try {
        const response: AxiosResponse<UpdateUserResponse> = await APICallInstance.patch(url, userData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const handleEditUserRole = async (userId: number, userRole: EditRoles) => {
    const url = `api/v1/users/${userId}/role?role=${userRole}`;

    try {
        const response: AxiosResponse<UpdateUserRoleResponse> = await APICallInstance.put(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
